import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 sm:py-24 px-4 bg-background" data-id="element-77">
      <div className="max-w-4xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-surfaceLight border border-accent/20 rounded-3xl p-8 sm:p-12 text-center relative overflow-hidden" data-id="element-79">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'radial-gradient(#D4A853 1px, transparent 1px)',
          backgroundSize: '24px 24px'
        }} data-id="element-80"></div>

          <div className="relative z-10" data-id="element-81">
            <div className="w-20 h-20 mx-auto bg-accent/10 rounded-full flex items-center justify-center mb-6 border border-accent/30" data-id="element-82">
              <ShieldIcon className="w-10 h-10 text-accent" data-id="element-83" />
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl text-text mb-6" data-id="element-84">
              Garantía de "Resultado o Dinero" de 7 Días
            </h2>

            <p className="text-lg text-textMuted leading-relaxed max-w-2xl mx-auto mb-6" data-id="element-85">
              Si después de armar tu primera escultura sientes que no parece una
              obra de arte, o si simplemente no te gusta el tipo de letra del
              manual, envíanos un email y{' '}
              <strong className="text-text" data-id="element-86">
                te devolvemos tus $9.99. Sin preguntas.
              </strong>
            </p>

            <p className="text-accent font-medium" data-id="element-87">
              Te quedas con las plantillas de todos modos como regalo por
              intentarlo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}